// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2PkOE","label":"SetPasswdForm_label__3UnGI"};